import UcFirst from "../../components/helpers/UcFirst";

export const initFilterInput = {
  searchName: "",
  isUsed: '',
  page: 1,
  pageSize: 10,
};

export const filterIsUsed = [
  {
    label: "Semua",
    value: "",
  },
  {
    label: "Sudah Digunakan",
    value: "true",
  },
  {
    label: "Belum Digunakan",
    value: "false",
  },
];

export const renderColumns = (onCheck, checkAll, onCheckAll) => {
  return [
    {
      dataIndex: "checkbox",
      key: "checkbox",
      title: (
        <input
          type="checkbox"
          id={`label-check-all`}
          checked={checkAll}
          onClick={(event) => onCheckAll()}
        />
      ),
      render: (_, record) => (
        <input
          type="checkbox"
          id={`label-check-${record.id}`}
          checked={record.is_checked}
          onClick={(event) => onCheck(record)}
        />
      ),
    },
    {
      dataIndex: "label_code",
      key: "label_code",
      title: "Kode Label",
    },
    {
      dataIndex: "sbg_code",
      key: "sbg_code",
      title: "No. Surat Bukti Gadai",
      render: (_, record) => (
        <p className="m-0">{record.gadai?.sbg_code || ""}</p>
      ),
    },
    {
      dataIndex: "receipt_code",
      key: "receipt_code",
      title: "No. Kwitansi",
      render: (_, record) => (
        <p className="m-0">{record.gadai?.receipt_code || ""}</p>
      ),
    },
    {
      dataIndex: "customer_name",
      key: "customer_name",
      title: "Nama Nasabah",
      render: (_, record) => (
        <p className="m-0">{record.gadai?.ktp_name || ""}</p>
      ),
    },
    {
      dataIndex: "item_description",
      key: "item_description",
      title: "Keterangan Barang",
      render: (_, record) => (
        <>
          {record.gadai?.gadai_type === "smartphone" ? (
            <div>
              <p className="m-0">
                {<UcFirst text={record.gadai.gadai_type} />} -{" "}
                {record.gadai.gadai_smartphone.smartphone_brand.name}
              </p>
              <p className="m-0">
                {record.gadai.gadai_smartphone.smartphone_model.name}
              </p>
            </div>
          ) : record.gadai?.gadai_type === "car" ? (
            <div>
              <p className="m-0">
                {<UcFirst text={record.gadai.gadai_type} />} -{" "}
                {record.gadai.gadai_car.car_brand.name}
              </p>
              <p className="m-0">
                {record.gadai.gadai_car.car_model.name} -{" "}
                {record.gadai.gadai_car.car_year.name}
              </p>
            </div>
          ) : record.gadai?.gadai_type === "bike" ? (
            <div>
              <p className="m-0">
                {<UcFirst text={record.gadai.gadai_type} />} -{" "}
                {record.gadai.gadai_bike.bike_brand.name}
              </p>
              <p className="m-0">
                {record.gadai.gadai_bike.bike_model.name} -{" "}
                {record.gadai.gadai_bike.bike_year.name}
              </p>
            </div>
          ) : record.gadai?.gadai_type === "bpkb" ? (
            <div>
              <p className="m-0">
                {<UcFirst text={record.gadai.gadai_type} />} -{" "}
                {record.gadai.gadai_bpkb.bike_brand?.name ||
                  record.gadai.gadai_bpkb.car_brand?.name}
              </p>
              <p className="m-0">
                {record.gadai.gadai_bpkb.bike_model?.name ||
                  record.gadai.gadai_bpkb.car_model?.name}{" "}
                -{" "}
                {record.gadai.gadai_bpkb.bike_year?.name ||
                  record.gadai.gadai_bpkb.car_year?.name}
              </p>
            </div>
          ) : record.gadai?.gadai_type === "other" ?
            <div>
              <p className="m-0">
                {record.gadai.gadai_other?.name}
              </p>
            </div> :
            (
              ""
            )}
        </>
      ),
    },
  ];
};
